import * as React from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { TipoDatos } from "../../config_general/modelo/TipoDatos";
import { Glosa } from "../modelo/AdminGlosas";
import { Form } from "react-final-form";
import TextoInput from "../../../general/componentes/TextoInput";
import DatePickerSura from "../../../general/componentes/DatePicker";
import TiposGestion from "../../inconsistencias/componentes/TiposGestion";
import InterruptorSN from "../../config_general/componentes/InterruptorSN";
import InputTextBox from "../../config_general/componentes/InputTextBox";
import * as moment from "moment";
import DatePicker from "react-datepicker";
import TiposTransacciones from "../../../general/componentes/TiposTransacciones";
import { TransaccionSat } from "../../../general/modelo/TransaccionSat";

export class ModalGestionarGlosa extends React.Component<ModalGestionarGlosaProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div>
                <Modal bsSize="large" backdrop='static' show={this.props.show} onHide={this.cancelar}>
                    <Modal.Body>
                        {this.renderFormularioGlosas()}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    renderFormularioGlosas = () => {
        const {
            esCrear,
            servicio,
            codigoGlosa,
            tipoGestion,
            esBloqueante,
            descripcion,
            validacion,
            mensajeUsuario,
            fechaAlta,
            fechaBaja
        } = this.props;

        const dateFechaAlta = () => {
            if (fechaAlta) {
                const date = new Date(fechaAlta);
                return moment(date.setDate(date.getDate() + 1), DatePicker.DATE_FORMAT);
            }
            return undefined;
        };

        const dateFechaBaja = () => {
            if (fechaBaja) {
                const date = new Date(fechaBaja);
                return moment(date.setDate(date.getDate() + 1), DatePicker.DATE_FORMAT);
            }
            return undefined;
        };

        return (
            <div>
                <Form
                    onSubmit={this.onSubmit}
                    validate={this.validate}
                    initialValues={{
                        servicio: servicio ? servicio.nombre : undefined,
                        codigoGlosa: codigoGlosa,
                        tipoGestion: tipoGestion,
                        snBloqueante: esBloqueante,
                        descripcion: descripcion,
                        validacion: validacion,
                        mensajeUsuario: mensajeUsuario,
                        fechaAlta: dateFechaAlta(),
                        fechaBaja: dateFechaBaja()
                    }}
                    render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                        <form onSubmit={handleSubmit}>
                            <div className={"card"}>
                                <div className={"card-header"}>
                                    <h3 className={"panel-title"}>{this.props.titulo}</h3>
                                </div>
                                <div className={"card-body"}>
                                    <Row className={"form-group"}>
                                        <Col sm={3}>
                                            <label htmlFor="servicio">Servicio</label>
                                            {
                                                this.renderSelectorServicio(esCrear)
                                            }
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="codigoGlosa">Código Glosa</label>
                                            <TextoInput name="codigoGlosa" placeholder="Ingrese valor" maxLength={100} disabled={!esCrear} />
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="tipoGestion">Tipo Gestión</label>
                                            <TiposGestion name={"tipoGestion"} />
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="snBloqueante">Es Bloqueante</label>
                                            <InterruptorSN name={"snBloqueante"} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="validacion">Validación</label>
                                            <InputTextBox name={"validacion"} tamano={100} maxLength={2000} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="descripcion">Descripción</label>
                                            <InputTextBox name={"descripcion"} tamano={100} maxLength={2000} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="mensajeUsuario">Mensaje Usuario</label>
                                            <InputTextBox name={"mensajeUsuario"} tamano={100} maxLength={2000} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={3}>
                                            <label htmlFor="fechaAlta">Fecha Alta</label>
                                            <DatePickerSura name={"fechaAlta"} />
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="fechaBaja">Fecha Baja</label>
                                            <DatePickerSura name={"fechaBaja"} />
                                        </Col>
                                    </Row>
                                    <div style={{ marginTop: `25px` }}>
                                        <Modal.Footer>
                                            <Button type="submit" className={"btns btns-primary"} disabled={submitting || invalid} >Aceptar</Button>
                                            <Button className={"btns btns-secondary"} onClick={this.cancelar}>Cancelar</Button>
                                        </Modal.Footer>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                />
            </div>
        );
    }

    renderSelectorServicio = (esCrear: boolean) => {
        return esCrear ? <TiposTransacciones name="servicio" />
            : <TextoInput name="servicio" disabled />;
    };

    validate = (values: any) => {
        const errors = {
            servicio: undefined,
            codigoGlosa: undefined,
            fechaAlta: undefined
        };

        if (!values.servicio)
            errors.servicio = "Por favor ingrese el servicio";
        if (!values.codigoGlosa)
            errors.codigoGlosa = "Por favor ingrese el codigo de la glosa";
        if (!values.fechaAlta)
            errors.fechaAlta = "Por favor ingrese la fecha de alta";

        return errors;
    }

    onSubmit = (values: any) => {
        const servicio = () => {
            if (this.props.esCrear)
                return values.servicio ? Number(values.servicio) : undefined;
            return this.props.servicio.codigo;
        };
        const codigoGlosa = values.codigoGlosa ? values.codigoGlosa.valueOf() : undefined;
        const tipoGestion = values.tipoGestion ? values.tipoGestion.valueOf() : undefined;
        const snBloqueante = values.snBloqueante;
        const validacion = values.validacion ? values.validacion.valueOf() : undefined;
        const descripcion = values.descripcion ? values.descripcion.valueOf() : undefined;
        const mensajeUsuario = values.mensajeUsuario ? values.mensajeUsuario.valueOf() : undefined;
        const fechaAlta = values.fechaAlta ? values.fechaAlta.format("YYYY-MM-DD").valueOf() : undefined;
        const fechaBaja = values.fechaBaja ? values.fechaBaja.format("YYYY-MM-DD").valueOf() : undefined;

        const glosa: Glosa = {
            tipo: TipoDatos.GLOSA,
            consecutivo: this.props.consecutivo,
            consecutivoServicio: servicio(),
            codigoGlosa: codigoGlosa,
            validacion: validacion,
            mensajeUsuario: mensajeUsuario,
            tipoGestion: tipoGestion,
            descripcion: descripcion,
            fechaAlta: fechaAlta,
            fechaBaja: fechaBaja,
            esBloqueante: snBloqueante,
            dniIngreso: this.props.dniIngreso,
            fechaIngresa: this.props.fechaIngresa
        };

        this.props.onAceptar(glosa);
    }

    cancelar = () => {
        this.props.onCancelar();
    }
}

interface ModalGestionarGlosaProps {
    titulo: string,
    esCrear: boolean,
    consecutivo: number,
    servicio: TransaccionSat,
    codigoGlosa: string,
    validacion: string,
    mensajeUsuario: string,
    tipoGestion: string,
    descripcion: string,
    fechaAlta: string,
    fechaBaja: string,
    dniIngreso: string,
    fechaIngresa: string,
    esBloqueante: boolean,
    show: boolean,
    onAceptar?: (parametro: Glosa) => void;
    onCancelar?: () => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_glosas/componentes/ModalGestionarGlosa.tsx